__turbopack_context__.v({
  "label": "RegionSelector-module__uE8frq__label",
  "trigger": "RegionSelector-module__uE8frq__trigger",
});
